export default class AddSignatureFailedError extends Error {
    name = 'AddSignatureFailedError';
}